import { getThreeDCBase } from "./threeDCConfig";

const parseResponse = async (response) => {
  const text = await response.text();
  let data = {};

  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    throw new Error(`3D C returned invalid JSON (HTTP ${response.status}).`);
  }

  if (!response.ok || data?.ok === false) {
    throw new Error(data?.error || `3D C request failed (${response.status}).`);
  }

  return data;
};

export const threeDCFetch = async (path, options = {}) => {
  const response = await fetch(`${getThreeDCBase()}/${String(path).replace(/^\/+/, "")}`, {
    ...options,
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(options.headers || {}),
    },
  });

  return parseResponse(response);
};

export const threeDCPost = (path, payload) =>
  threeDCFetch(path, {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const getThreeDCStatus = () => threeDCFetch("status.php");
export const getThreeDCWorkflows = () => threeDCFetch("workflows.php");
export const saveThreeDCWorkflow = (workflow) => threeDCPost("workflows.php", workflow);
export const analyzeThreeDCProfile = (payload) => threeDCPost("analyze.php", payload);
export const runThreeDCConnector = (name, profile) => threeDCPost(`${name}.php`, { profile });
export const generateThreeDCReport = (runUuid) =>
  threeDCPost("report.php", { run_uuid: runUuid });
export const getThreeDCReportUrl = (runUuid) =>
  `${getThreeDCBase()}/report.php?run_uuid=${encodeURIComponent(runUuid)}`;
export const getThreeDCLlmSettings = () => threeDCFetch("llm-settings.php");

export const getThreeDCHistory = ({
  page = 1,
  pageSize = 10,
  search = "",
  status = "",
  model = "",
} = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  if (search) params.set("search", search);
  if (status) params.set("status", status);
  if (model) params.set("model", model);
  return threeDCFetch(`history.php?${params}`);
};

export const getThreeDCRun = (runUuid) =>
  threeDCFetch(`run.php?run_uuid=${encodeURIComponent(runUuid)}`);
